import React, { CSSProperties, PropsWithChildren } from 'react';
import * as S from './styles';

export type HeadingSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export type HeadingProps = PropsWithChildren<{
  $size: HeadingSize;
  $priority: HeadingSize;
  $color: 'neutral' | 'accent';
  $weight: 'light' | 'regular' | 'medium' | 'bold';
  $align: 'left' | 'center' | 'right';
  $highContrast: boolean;
  $text: string;
  $quebraTexto?: boolean;
  style?: CSSProperties;
}>;

export default function Heading(props: HeadingProps) {
  const { $priority, $text, $quebraTexto = true, style = {} } = props;
  const propsContainer = { ...props, $quebraTexto };
  return (
    <S.Container
      style={style}
      as={`h${$priority < 6 ? $priority : 6}`}
      {...propsContainer}
    >
      {$text}
    </S.Container>
  );
}
